import React, {useEffect, useState} from "react";
import styled from "styled-components";
import tickMark from "../../../../../../assets/tickMark.svg";
import calendarIcon from "../../../../../../assets/calendarIcon.svg";
import clockIcon from "../../../../../../assets/clockIcon.svg";
import forkIcon from "../../../../../../assets/forkIcon.svg";
import deliveryIcon from "../../../../../../assets/deliveryIcon.png";
import lunchSpecial from "../../../../../../assets/lunchSpecial.png";
import Button from "components/molecules/Button";
import Form from "components/molecules/Form/Form";
import {useForm} from "components/molecules/Form";
import {IoCheckmark} from "react-icons/io5";
import ModalContainer from "components/molecules/ModalContainer";
import DeleteModal from "components/atoms/DeleteModal/Index";
import SuccessModal from "components/atoms/SuccessModal";

const StyledReviewSave = styled(Form)`
    width: 100%;
    .success-wrap {
        padding: 16px;
        border-radius: 15px;
        background-color: rgba(39, 196, 83, 0.1);
        text-align: center;
        margin-bottom: 30px;
        .tickMark {
            margin-bottom: 10px;
        }
        .title {
            display: block;
            color: rgba(39, 196, 83, 1);
            font-size: 18px;
            line-height: 22px;
            font-weight: 400;
            margin-bottom: 6px;
        }
        .desc {
            color: var(--text-color);
            font-size: 14px;
            line-height: 18px;
            font-weight: 300;
        }
    }
    .preview-wrap {
        border: 1px solid rgba(236, 236, 236, 1);
        border-radius: 10px;
        margin-bottom: 30px;
        .preview-head {
            padding: 20px 15px;
            border-radius: 10px 10px 0 0;
            background-color: var(--primary);
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
            .title {
                color: var(--white);
                font-size: 24px;
                line-height: 28px;
                font-weight: 400;
                margin: 0;
            }
            .title-wrap {
                background-color: var(--white);
                color: var(--text-color);
                font-size: 12px;
                line-height: 16px;
                font-weight: 400;
                padding: 7px 10px;
                border-radius: 30px;
            }
        }

        .preview-details {
            display: flex;
            flex-direction: column;
            gap: 24px;
            padding: 35px 20px 20px;
            @media (min-width: 576px) {
                flex-direction: row;
            }
            .img-wrap {
                width: 100px;
                height: 100px;
                border-radius: 10px;
            }
            .details {
                .title {
                    color: var(--text-color);
                    font-size: 24px;
                    line-height: 28px;
                    font-weight: 400;
                    margin-bottom: 10px;
                }
                .desc {
                    display: block;
                    color: var(--text-color);
                    margin-bottom: 15px;
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 300;
                }
                .price {
                    display: block;
                    color: rgba(39, 196, 83, 1);
                    font-size: 24px;
                    line-height: 28px;
                    font-weight: 600;
                    margin-bottom: 15px;
                }
                .btn {
                    color: var(--white);
                    background-color: var(--primary);
                    padding: 5px 10px;
                    font-size: 12px;
                    line-height: 16px;
                    font-weight: 400;
                    border-radius: 30px;
                }
            }
        }
    }
    .item-details-wrap {
        display: flex;
        gap: 10px;
        margin-bottom: 16px;
        flex-direction: column;
        @media (min-width: 768px) {
            flex-direction: row;
            gap: 20px;
        }
        .items-wrap {
            width: 100%;
            padding: 20px;
            border: 1px solid rgba(236, 236, 236, 1);
            border-radius: 13px;
            .title {
                font-size: 18px;
                line-height: 22px;
                font-weight: 400;
                margin-bottom: 20px;
            }
            .items-list {
                list-style: none;
                display: flex;
                gap: 15px;
                li {
                    .heading {
                        display: block;
                        margin-bottom: 10px;
                        font-size: 14px;
                        line-height: 18px;
                        font-weight: 500;
                    }
                    .items {
                        list-style: none;
                        display: flex;
                        flex-wrap: wrap;
                        gap: 15px;
                        li {
                            display: flex;
                            align-items: center;
                            gap: 10px;
                            font-size: 13px;
                            line-height: 17px;
                            font-weight: 400;
                        }
                    }
                }
            }
        }
        .pricing-wrap {
            width: 100%;
            padding: 20px;
            border: 1px solid rgba(236, 236, 236, 1);
            border-radius: 13px;
            .title {
                font-size: 18px;
                line-height: 22px;
                font-weight: 400;
                margin-bottom: 20px;
            }
            .price-list {
                list-style: none;
                .li {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 12px;
                    margin-bottom: 15px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                    .label {
                        font-size: 14px;
                        line-height: 18px;
                        font-weight: 300;
                        &.success {
                            color: rgba(39, 196, 83, 1);
                        }
                    }
                    strong {
                        color: rgba(39, 196, 83, 1);
                        font-size: 14px;
                        line-height: 18px;
                        font-weight: 400;
                    }
                    del {
                        color: rgba(205, 205, 205, 1);
                        font-size: 14px;
                        line-height: 18px;
                        font-weight: 400;
                    }
                }
            }
        }
    }
    .service-wrap {
        width: 100%;
        padding: 20px;
        border: 1px solid rgba(236, 236, 236, 1);
        border-radius: 13px;
        margin-bottom: 30px;
        .title {
            font-size: 18px;
            line-height: 22px;
            font-weight: 400;
            margin-bottom: 20px;
        }
        .services-list {
            list-style: none;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            gap: 16px;
            @media (min-width: 576px) {
                grid-template-columns: repeat(3, 1fr);
            }
            li {
                strong {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-size: 14px;
                    line-height: 18px;
                    font-weight: 400;
                    margin-bottom: 10px;
                }
                .desc {
                    font-size: 12px;
                    line-height: 16px;
                    font-weight: 300;
                }
                .days-wrap {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 8px;
                    .day {
                        padding: 5px 10px;
                        font-size: 12px;
                        line-height: 16px;
                        font-weight: 400;
                        border: 1px solid rgba(205, 205, 205, 1);
                        border-radius: 30px;
                    }
                }
                .delivery {
                    width: max-content;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    padding: 5px 10px;
                    font-size: 13px;
                    line-height: 17px;
                    font-weight: 400;
                    border: 1px solid rgba(205, 205, 205, 1);
                    border-radius: 30px;
                }
            }
        }
    }
    .ready-wrap {
        padding: 20px 15px;
        border-radius: 15px;
        background-color: rgba(245, 126, 42, 0.1);
        text-align: center;
        margin-bottom: 40px;
        .title {
            color: var(--primary);
            font-size: 18px;
            line-height: 22px;
            font-weight: 400;
            margin-bottom: 10px;
        }
        .desc {
            color: var(--text-color);
            font-size: 14px;
            line-height: 18px;
            font-weight: 300;
            margin-bottom: 20px;
        }
        .list-wrap {
            list-style: none;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 12px;
            flex-direction: column;
            @media (min-width: 576px) {
                flex-direction: row;
                gap: 20px;
            }
            li {
                color: var(--primary);
                display: flex;
                align-items: center;
                gap: 12px;
                font-size: 14px;
                line-height: 18px;
                font-weight: 400;
            }
        }
    }
    .btn-holder {
        @media (min-width: 576px) {
            display: flex;
            gap: 21px;
        }
        .btn {
            width: 100%;
            &:first-child {
                @media (max-width: 575px) {
                    margin-bottom: 10px;
                }
            }
        }
    }
`;

const days = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

const ReviewSave = ({formData, setSuccessModal, setActiveTab, onClose}) => {
    const [form] = useForm();

    const [itemUrl, setItemUrl] = useState(null);

    useEffect(() => {
        if (formData?.form1?.itemImg) {
            const objectUrl = URL.createObjectURL(formData.form1.itemImg);
            setItemUrl(objectUrl);

            return () => URL.revokeObjectURL(objectUrl);
        } else {
            setItemUrl(null);
        }
    }, [form, formData?.form1?.itemImg]);

    console.log({formData});

    function handleSubmit(e) {
        console.log(e);
        onClose();
        setSuccessModal(true);
    }

    const calculateDiscount = (basePrice, originalPrice) => {
        const percentage = (basePrice / originalPrice) * 100;
        return 100 - percentage;
    };
    return (
        <>
            <StyledReviewSave form={form} onSubmit={handleSubmit}>
                <div className="success-wrap">
                    <img src={tickMark} alt="tickMark" className="tickMark" />
                    <strong className="title">Almost Ready!</strong>
                    <span className="desc">
                        Review your combo details below and click "Save Combo" to make it available to customers.
                    </span>
                </div>
                <div className="preview-wrap">
                    <div className="preview-head">
                        <h2 className="title">Combo Preview</h2>
                        <span className="title-wrap">Chef Special</span>
                    </div>
                    <div className="preview-details">
                        <img src={itemUrl ?? lunchSpecial} alt="img" className="img-wrap" />
                        <div className="details">
                            <h2 className="title">{formData?.form1?.comboName ?? "Lunch Special"}</h2>
                            <span className="desc">
                                {formData?.form1?.description ?? "Perfect combo for your lunch break"}
                            </span>
                            <strong className="price">${formData?.form3?.comboPrice ?? "14.99"}</strong>
                            <span className="btn">Ready to launch</span>
                        </div>
                    </div>
                </div>

                <div className="item-details-wrap">
                    <div className="items-wrap">
                        <h2 className="title">Items Included</h2>
                        <ul className="items-list">
                            <li>
                                <strong className="heading">Main Item</strong>
                                <ul className="items">
                                    <li>
                                        <IoCheckmark color="rgba(39, 196, 83, 1)" size={20} />
                                        Zinger Burger
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <strong className="heading">Side Item</strong>
                                <ul className="items">
                                    <li>
                                        <IoCheckmark color="rgba(39, 196, 83, 1)" size={20} />
                                        Fries
                                    </li>
                                    <li>
                                        <IoCheckmark color="rgba(39, 196, 83, 1)" size={20} />
                                        Onion Rings
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>

                    <div className="pricing-wrap">
                        <h2 className="title">Pricing Details</h2>
                        <ul className="price-list">
                            <li className="li">
                                <span className="label">Combo Price:</span>
                                <strong>${formData?.form3?.comboPrice ?? "14.99"}</strong>
                            </li>
                            <li className="li">
                                <span className="label">Original Price:</span>
                                <del>${formData?.form3?.originalPrice ?? "24.00"}</del>
                            </li>
                            <li className="li">
                                <span className="label success">Customer Saves:</span>
                                <strong>
                                    $
                                    {(
                                        Math.floor(
                                            (formData?.form3?.originalPrice - formData?.form3?.comboPrice) * 100
                                        ) / 100
                                    ).toFixed(2)}{" "}
                                    (
                                    {Number(
                                        Math.floor(
                                            calculateDiscount(
                                                formData?.form3?.comboPrice,
                                                formData?.form3?.originalPrice
                                            ) * 100
                                        ) / 100
                                    )
                                        .toString()
                                        .replace(/\.00$/, "")}
                                    %)
                                </strong>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="service-wrap">
                    <h2 className="title">Availability & Service</h2>
                    <ul className="services-list">
                        <li>
                            <strong>
                                <img src={calendarIcon} alt="icon" />
                                Available Day
                            </strong>
                            <div className="days-wrap">
                                {days.filter(day => formData?.form4?.availableDays[day]).length === 0
                                    ? "No days selected"
                                    : days
                                          .filter(day => formData?.form4?.availableDays[day])
                                          .map(day => <span className="day">{day}</span>)}
                            </div>
                        </li>
                        <li>
                            <strong>
                                <img src={clockIcon} alt="icon" />
                                Time Slot
                            </strong>
                            <span className="desc">{formData?.form4?.timeSlot ?? "Lunch (11:00 AM - 4:00 PM)"}</span>
                        </li>
                        <li>
                            <strong>
                                <img src={forkIcon} alt="icon" />
                                Service Options
                            </strong>
                            <span className="delivery">
                                <img src={deliveryIcon} alt="icon" />
                                Delivery
                            </span>
                        </li>
                    </ul>
                </div>

                <div className="ready-wrap">
                    <h2 className="title">Ready to Launch Your Combo?</h2>
                    <p className="desc">
                        Once you save this combo, it will be available to customers immediately based on your
                        availability settings.
                    </p>
                    <ul className="list-wrap">
                        <li>
                            <IoCheckmark color="var(--primary)" size={20} />
                            Items selected
                        </li>
                        <li>
                            <IoCheckmark color="var(--primary)" size={20} />
                            Pricing set
                        </li>
                        <li>
                            <IoCheckmark color="var(--primary)" size={20} />
                            Availability configured
                        </li>
                    </ul>
                </div>
                <div className="btn-holder">
                    <Button type="button" $gray className="btn" onClick={() => setActiveTab(3)}>
                        Previous
                    </Button>

                    <Button className="btn">Save Combo</Button>
                </div>
            </StyledReviewSave>
        </>
    );
};

export default ReviewSave;
